<script>
export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'match-detail-demo-tab-two',

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            tabTwoData: {},
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        firstItemLabel() {
            return this.tabTwoData.firstItem ? this.tabTwoData.firstItem.label : ''
        },
        secondItemLabel() {
            return this.tabTwoData.secondItem ? this.tabTwoData.secondItem.label : ''
        },
        localeLabel() {
            return this.locale.submit
        }
    },
}
</script>

<template>
    <div>
        <p>Tab Two</p>
        <p>{{ firstItemLabel }}</p>
        <p>{{ secondItemLabel }}</p>
        <p>{{ locale.submit }}</p>
    </div>
</template>